import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { ISubConstructive } from './interfaces';

export const getSubConstructiveList = (data: IDynamicTableParams) => {
  return instance()
    .post<ISubConstructive[]>('/element/list', data)
    .then((response) => response.data);
};

export const getSubConstructiveAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/element/availableColumns')
    .then((response) => response.data);
};

export const getSubConstructiveAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/element/availableGroupColumns')
    .then((response) => response.data);
};

export const loadSubConstructive = (elementId: number) => {
  return instance()
    .get<ISubConstructive>('/element/load/' + elementId)
    .then((response) => response.data);
};

export const createSubConstructive = (subconstructive: ISubConstructive) => {
  return instance()
    .post<ISubConstructive>('/element/save', subconstructive)
    .then((response) => response.data);
};

export const updateSubConstructive = (subconstructive: ISubConstructive) => {
  return instance()
    .post<ISubConstructive>(`/element/${subconstructive.elementId}/update`, subconstructive)
    .then((response) => response.data);
};

export const deleteSubConstructive = (elementId: number) => {
  return instance()
    .post('/element/archive', { elementId })
    .then((response) => response.data);
};

export const recoverSubConstructive = (elementId: number) => {
  return instance()
    .post('/element/recover', { elementId })
    .then((response) => response.data);
};
